import { COLORS } from 'constants/colors';
import { FEE_TABLE_ROWS } from 'constants/parking';
import { useTranslation } from 'react-i18next';
import styles from './ParkingFeeTable.module.scss';

export default function ParkingFeeTable() {
  const { t } = useTranslation();

  return (
    <div className={styles.ParkingFeeTable}>
      <div className={styles.fee_title}>
        <div className={styles.left_bar} />
        <div className={styles.title_text}>{t('parking.feeTable.parkingFeeInformation')}</div>
      </div>

      <div className={styles.fee_table_container}>
        <div className={styles.fee_table}>
          {FEE_TABLE_ROWS.map((row, index) => {
            return (
              <div
                key={index}
                style={{
                  borderBottomColor: index === FEE_TABLE_ROWS.length - 1 ? COLORS.GRAY_44 : COLORS.GRAY_CC,
                }}
                className={styles.table_row}
              >
                <div className={styles.table_title}>{t(`${row.title}`)}</div>
                <div className={styles.table_multi_columns}>
                  {row.descriptions.map((desc, descIndex) => (
                    <div key={`desc-${descIndex}`}>{t(`${desc}`)}</div>
                  ))}
                </div>
                <div className={styles.table_multi_columns}>
                  {row.notes.map((note, noteIndex) => (
                    <div key={`note-${noteIndex}`}>{t(`${note}`)}</div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.exception}>※ {t('parking.feeTable.exception')}</div>
      </div>
    </div>
  );
}
